export default __webpack_public_path__ + "static/media/red-triangle.b7824fb9.svg";